import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Archive = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Archive' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M3,23 L21,23 L21,6 L3,6 L3,23 Z M9,14 L15,14 L15,10 L9,10 L9,14 Z M1,6 L23,6 L23,1 L1,1 L1,6 Z' />
  </StyledIcon>
);
